<template>
  <!-- No changes to template section -->
  <el-dialog  width="70%"   v-model="dialogVisible">
    <template #header>
      <div class="card-header">
        <span>{{ isEdit ? '编辑产品' : '添加产品' }}</span>
        <div class="header-actions">
          <el-button type="info" @click="fillTestData" v-if="!isEdit">填充测试数据</el-button>
          <el-button type="primary" @click="() => $refs.fileInput.click()">选择表格</el-button>
          <input ref="fileInput" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" @change="handleFileChange" />
        </div>
      </div>
    </template>

    <el-form :model="form" :rules="rules" ref="form" label-width="120px" v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="银行" prop="bank_id">
            <el-select v-model="form.bank_id" filterable allow-create default-first-option @change="handleBankChange" style="width: 100%">
              <el-option
                v-for="bank in banks"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="贷款类型" prop="loan_type">
            <el-select v-model="form.loan_type" multiple filterable allow-create default-first-option @change="handleLoanTypeChange" style="width: 100%">
              <el-option
                v-for="bank in loanTypes"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="贷款用途" prop="loan_purpose">
            <el-select v-model="form.loan_purpose" multiple filterable allow-create default-first-option @change="handleLoanPurposeChange" style="width: 100%">
              <el-option
                v-for="bank in loanPurposes"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="最低利率" prop="interest_rate_min">
            <el-input-number 
              v-model="form.interest_rate_min" 
              :min="0" 
              :precision="2"
              placeholder="最低利率"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="还款方式" prop="repayment_method">
            <el-select v-model="form.repayment_method" multiple filterable allow-create default-first-option @change="handleRepaymentMethodChange" style="width: 100%">
              <el-option
                v-for="bank in repaymentMethods"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="最高贷款金额" prop="loan_amount_max">
            <el-input-number 
              v-model="form.loan_amount_max" 
              :min="0" 
              :step="1000"
              placeholder="最高贷款金额"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="最大贷款成数LVR" prop="max_lvr_percent">
            <el-input-number 
              v-model="form.max_lvr_percent" 
              :min="0" 
              :max="100"
              :precision="0"
              placeholder="最大贷款成数"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="借款人类型" prop="borrower_type">
            <el-select
              v-model="form.borrower_type"
              placeholder="请选择借款人类型"
              style="width: 100%"
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in borrowerTypes"
                :key="item.code"
                :label="item.code"
                :value="item.code"
              >
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ item.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ item.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="产品系列" prop="product_series">
            <el-select v-model="form.product_series" filterable allow-create default-first-option @change="handleProductSeriesChange" style="width: 100%">
              <el-option
                v-for="bank in productSeries"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :lg="8" :md="12" :sm="24" :xs="24">
          <el-form-item label="文件类型" prop="doc_type">
            <el-select v-model="form.doc_type" filterable allow-create default-first-option @change="handleDocTypeChange" style="width: 100%">
              <el-option
                v-for="bank in docTypes"
                :key="bank.code"
                :value="bank.code">
                <div style="line-height: 1.5;">
                  <div style="font-size: 14px;">{{ bank.code }}</div>
                  <div style="font-size: 12px; color: #999;">{{ bank.name }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="备注信息" prop="notes">
        <el-input type="textarea" v-model="form.notes" rows="10"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>


<script>
import axios from 'axios'
import { getDict } from '@/utils/dictCache'
import * as XLSX from 'xlsx'
import Papa from 'papaparse'

export default {
  name: 'ProductForm',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      isEdit: false,
      form: {
        bank_id: '',
        product_name: '',
        loan_type: '',
        loan_purpose: '',
        interest_type: '',
        interest_rate_min: '',
        interest_rate_max: '',
        loan_term_options: '',
        repayment_method: '',
        repayment_frequency: '',
        min_deposit_percent: '',
        max_lvr_percent: '',
        loan_amount_min: '',
        loan_amount_max: '',
        applicable_people: [],
        location_applicable: '',
        government_support: '',
        early_repayment_penalty: '',
        repayment_flexibility: '',
        credit_score_required: 0,
        lenders_mortgage_insurance: '',
        loan_fees: '',
        application_channel: [],
        contact_info: '',
        branch_location: '',
        support_services: [],
        borrower_type: [],
        notes: '',
        is_active: true,
        application_fee: 0,
        valuation_fee: 0,
        annual_fee: 0,
        product_series: '',
        doc_type: ''
      },
      rules: {
        bank_id: [{ required: true, message: '请选择银行', trigger: 'change' }],
        product_name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        loan_type: [{ required: true, message: '请选择贷款类型', trigger: 'change' }],
        loan_purpose: [{ required: true, message: '请选择贷款用途', trigger: 'change' }],
        interest_type: [{ required: true, message: '请选择利率类型', trigger: 'change' }],
        interest_rate_min: [{ required: true, message: '请输入最低利率', trigger: 'blur' }],
        interest_rate_max: [{ required: true, message: '请输入最高利率', trigger: 'blur' }],
        loan_term_options: [{ required: true, message: '请输入贷款期限', trigger: 'blur' }],
        repayment_method: [{ required: true, message: '请选择还款方式', trigger: 'change' }],
        repayment_frequency: [{ required: true, message: '请选择还款频率', trigger: 'change' }],
        min_deposit_percent: [{ required: true, message: '请输入最低首付比例', trigger: 'blur' }],
        max_lvr_percent: [{ required: true, message: '请输入最大贷款成数', trigger: 'blur' }],
        loan_amount_min: [{ required: true, message: '请输入最低贷款金额', trigger: 'blur' }],
        loan_amount_max: [{ required: true, message: '请输入最高贷款金额', trigger: 'blur' }],
        applicable_people: [{ required: true, message: '请选择适用人群', trigger: 'change' }],
        application_channel: [{ required: true, message: '请选择申请渠道', trigger: 'change' }],
        borrower_type: [{ required: true, message: '请选择借款人类型', trigger: 'change' }],
        application_fee: [{ required: true, message: '请输入申请费', trigger: 'blur' }],
        valuation_fee: [{ required: true, message: '请输入评估费', trigger: 'blur' }],
        annual_fee: [{ required: true, message: '请输入年费', trigger: 'blur' }],
        product_series: [{ required: true, message: '请选择产品系列', trigger: 'change' }],
        doc_type: [{ required: true, message: '请选择文件类型', trigger: 'change' }]
      }
    }
  },
  computed: {

    banks() {
      return getDict('BANK')
    },
    loanTypes() {
      return getDict('LOAN_TYPE')
    },
    loanPurposes() {
      return getDict('LOAN_PURPOSE')
    },
    interestTypes() {
      return getDict('INTEREST_TYPE')
    },
    repaymentMethods() {
      return getDict('REPAYMENT_METHOD')
    },
    repaymentFrequencies() {
      return getDict('REPAYMENT_FREQUENCY')
    },
    applicablePeople() {
      return getDict('APPLICABLE_PEOPLE')
    },
    applicationChannels() {
      return getDict('APPLICATION_CHANNEL')
    },
    borrowerTypes() {
      return getDict('BORROWER_TYPE')
    },
    supportServices() {
      return getDict('SUPPORT_SERVICES')
    },
    productSeries() {
      return getDict('PRODUCT_SERIES')
    },
    docTypes() {
      return getDict('DOC_TYPE')
    }
  },
  async created() {
    if (this.$route.params.id) {
      // await this.fetchProduct()
    }
  },
  methods: {
    show(data){
      if (data==null||data.id==null){
        this.isEdit = false

      }else {
        this.isEdit =true

        let data2 = JSON.parse(JSON.stringify(data))
        console.log(data2);
        
          data2.loan_purpose = data2.loan_purpose.split(',').filter(Boolean)
        data2.borrower_type = data2.borrower_type.split(',').filter(Boolean)
        data2.repayment_method = data2.repayment_method.split(',').filter(Boolean)
        data2.loan_type = data2.loan_type.split(',').filter(Boolean)
        // data2.support_services = data2.support_services.split(',').filter(Boolean)
        this.form = data2



      }
      this.dialogVisible = true
    },
    async fetchProduct() {
      this.loading = true
      try {
        const response = await axios.get(`https://aidata.haimoney.com.au/api/loan_products.php?id=${this.$route.params.id}`)
        const product = response.data

        // 确保所有字段都有初始值
        const formData = {
          bank_id: '',
          product_name: '',
          loan_type: '',
          loan_purpose: '',
          interest_type: '',
          interest_rate_min: '',
          interest_rate_max: '',
          loan_term_options: '',
          repayment_method: '',
          repayment_frequency: '',
          min_deposit_percent: '',
          max_lvr_percent: '',
          loan_amount_min: '',
          loan_amount_max: '',
          applicable_people: [],
          location_applicable: '',
          government_support: '',
          early_repayment_penalty: '',
          repayment_flexibility: '',
          credit_score_required: 0,
          lenders_mortgage_insurance: '',
          loan_fees: '',
          application_channel: [],
          contact_info: '',
          branch_location: '',
          support_services: [],
          borrower_type: [],
          notes: '',
          is_active: true,
          application_fee: 0,
          valuation_fee: 0,
          annual_fee: 0,
          product_series: '',
          doc_type: '',
          ...product
        }

        // 处理多选字段
        if (formData.applicable_people) {
          formData.applicable_people = formData.applicable_people.split(',').filter(Boolean)
        }
        if (formData.application_channel) {
          formData.application_channel = formData.application_channel.split(',').filter(Boolean)
        }
        if (formData.borrower_type) {
          formData.borrower_type = formData.borrower_type.split(',').filter(Boolean)
        }
        if (formData.support_services) {
          formData.support_services = formData.support_services.split(',').filter(Boolean)
        }

        this.form = formData
      } catch (error) {
        this.$message.error('获取产品信息失败')
        console.error(error)
      }
      this.loading = false
    },
    async submitForm() {
      try {
        await this.$refs.form.validate()

        const formData = { ...this.form }

        // 处理多选字段
        // if (Array.isArray(formData.applicable_people)) {
        //   formData.applicable_people = formData.applicable_people.join(',')
        // }
        // if (Array.isArray(formData.application_channel)) {
        //   formData.application_channel = formData.application_channel.join(',')
        // }
        // if (Array.isArray(formData.borrower_type)) {
        //   formData.borrower_type = formData.borrower_type.join(',')
        // }
        // if (Array.isArray(formData.support_services)) {
        //   formData.support_services = formData.support_services.join(',')
        // }

        // 确保必需字段都有值
        if (!formData.product_name) {
          this.$message.error('请输入产品名称')
          return
        }

        // 生成唯一ID

        let formData2 = null
        formData2 = JSON.parse(JSON.stringify(formData))
        // console.log(typeof formData2.applicable_people);
        // console.log( formData2.applicable_people);

        formData2.applicable_people = formData2.applicable_people.join(',')
        
        formData2.application_channel = formData2.application_channel.join(',')
        formData2.borrower_type = formData2.borrower_type.join(',')
        formData2.support_services = formData2.support_services.join(',')

        if (this.$route.params.id) {
          await axios.put(`https://aidata.haimoney.com.au/api/loan_products.php?id=${this.$route.params.id}`, formData2)
          this.$message.success('更新成功')
          this.dialogVisible = false
        } else {
          await axios.post('https://aidata.haimoney.com.au/api/loan_products.php', formData2)
          this.$message.success('创建成功')
          this.dialogVisible = false

        }

        this.$router.push('/products')
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('保存失败')
          console.error(error)
        }
      }
    },
    handleBankChange(value) {
      this.form.bank_id = value
    },
    handleLoanTypeChange(value) {
      this.form.loan_type = value
    },
    handleLoanPurposeChange(value) {
      this.form.loan_purpose = value
    },
    handleInterestTypeChange(value) {
      this.form.interest_type = value
    },
    handleRepaymentMethodChange(value) {
      this.form.repayment_method = value
    },
    handleRepaymentFrequencyChange(value) {
      this.form.repayment_frequency = value
    },
    handleProductSeriesChange(value) {
      this.form.product_series = value
    },
    handleDocTypeChange(value) {
      this.form.doc_type = value
    },
    fillTestData() {
      this.form = {
        bank_id: 'CBA',
        product_name: '测试贷款产品',
        loan_type: 'MORTGAGE',
        loan_purpose: 'PURCHASE',
        interest_type: 'FIXED',
        interest_rate_min: 5.5,
        interest_rate_max: 6.5,
        loan_term_options: '1-30年',
        repayment_method: 'PRINCIPAL_INTEREST',
        repayment_frequency: 'MONTHLY',
        min_deposit_percent: 20,
        max_lvr_percent: 80,
        loan_amount_min: 100000,
        loan_amount_max: 2000000,
        applicable_people: ['SELF_EMPLOYED', 'INVESTOR'],
        location_applicable: '悉尼、墨尔本、布里斯班',
        government_support: '支持首次购房者补贴',
        early_repayment_penalty: '提前还款可能需要支付额外费用',
        repayment_flexibility: '支持额外还款，无额外费用',
        credit_score_required: 700,
        lenders_mortgage_insurance: '贷款比例超过80%需要购买保险',
        loan_fees: '申请费：$500\n评估费：$300\n年费：$395',
        application_channel: ['ONLINE', 'BRANCH'],
        contact_info: '电话：1300 123 456\n邮箱：loans@testbank.com.au',
        branch_location: '悉尼市中心分行\n墨尔本市中心分行\n布里斯班市中心分行',
        support_services: ['ONLINE_BANKING', 'MOBILE_APP'],
        borrower_type: ['SALARIED', 'SELF_EMPLOYED'],
        notes: '这是一个测试产品，仅用于系统测试。',
        is_active: true,
        application_fee: 500,
        valuation_fee: 300,
        annual_fee: 395,
        product_series: '',
        doc_type: ''
      }
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.importProductsFromTable(file);
      // 清空 input 以便连续上传
      e.target.value = '';
    },
    async importProductsFromTable(file) {
      this.loading = true;
      try {
        let products = [];
        // 1. 识别文件类型
        const fileName = file.name.toLowerCase();
        if (fileName.endsWith('.csv')) {
          // 2. 解析 CSV
          const text = await file.text();
          const result = Papa.parse(text, { header: true, skipEmptyLines: true });
          if (result.errors.length) {
            throw new Error('CSV 解析失败: ' + result.errors[0].message);
          }
          products = result.data;
          if (products.length === 0) {
            console.log('CSV原文：', text);
          }
        } else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
          // 2. 解析 Excel
          const data = await file.arrayBuffer();
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          products = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
          if (products.length === 0) {
            console.log('Excel原始数据：', XLSX.utils.sheet_to_json(worksheet, { header: 1 }));
          }
        } else {
          throw new Error('仅支持 csv、xlsx、xls 文件');
        }
        console.log('products:', products);

        // 3. 校验字段（可选）
        if (!products.length) throw new Error('表格无有效数据');
        // 4. 调用后端批量导入接口
        const res = await axios.post('https://aidata.haimoney.com.au/api/loan_products.php?action=import', products);
        if (res.data && res.data.success) {
          this.$message.success('批量导入成功，共导入 ' + res.data.count + ' 条产品');
          this.dialogVisible = false;
          this.$emit('import-success');
        } else {
          throw new Error(res.data.error || '导入失败');
        }
      } catch (err) {
        this.$message.error('导入失败：' + (err.message || err));
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.product-form {
  padding: 15px;
  background-color: #f5f7fa;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.el-form {
  padding: 15px;
}

.el-row {
  margin-bottom: 10px;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-input-number {
  width: 100%;
}

.el-button {
  padding: 8px 20px;
}

.el-button + .el-button {
  margin-left: 8px;
}

.el-select {
  width: 100%;
}

.el-textarea__inner {
  min-height: 60px;
}

.el-form-item__label {
  font-weight: 500;
}

.el-input__inner {
  height: 32px;
  line-height: 32px;
}

.el-form-item.is-required .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.el-form-item__error {
  padding-top: 2px;
}

.el-message {
  min-width: 300px;
}

.el-message--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

.el-message--error {
  background-color: #fef0f0;
  border-color: #fde2e2;
}

.el-message__content {
  font-size: 14px;
}
</style>
